import { render, staticRenderFns } from "./my-menu.vue?vue&type=template&id=1b8083e2&scoped=true"
import script from "./my-menu.vue?vue&type=script&lang=js"
export * from "./my-menu.vue?vue&type=script&lang=js"
import style0 from "./my-menu.vue?vue&type=style&index=0&id=1b8083e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8083e2",
  null
  
)

export default component.exports